import { Box, Divider, Paper, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Header, MainColorButton } from "../../components";
import { PRESCRIPTION_DIRECTOR } from "../../routes/path";
import store from "../../store";
import { setPrescriptionType } from "../../store/actions/prescription";

/**
 * 処方箋種類選択
 * @returns
 */
const PrescriptionTypeSelector = () => {
  const [endY, setEndY] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const preState = location.state.prescription;
  const weekList = location.state.week;
  const guideType = true;
  return (
    <>
      <div
        onTouchStartCapture={(e) => {
          setEndY(0);
        }}
        onTouchMoveCapture={(e) => {
          setEndY(e.touches[0].clientY);
        }}
        onTouchEndCapture={(e) => {
          if (endY !== 0) {
            e.stopPropagation();
          }
        }}
      >
        <Header title="処方箋申込　[処方箋種類]" />
        <Box sx={{ height: "81vh", overflowY: "scroll" }} marginTop="9vh">
          <Typography
            variant="subtitle1"
            align="left"
            sx={{ width: "95%", marginRight: "auto", marginLeft: "auto" }}
          >
            処方箋提示種類を選択してください。
          </Typography>
          {preState.includes("4") && (
            <>
              <Stack width="95%" marginLeft="auto" marginRight="auto">
                <Stack
                  direction="row"
                  justifyContent="space-around"
                  alignItems="center"
                  alignSelf="baseline"
                  marginTop="5%"
                >
                  <MainColorButton
                    label="電子処方箋を送る"
                    onClick={() => {
                      store.dispatch(
                        setPrescriptionType({
                          id: "4",
                          name: "電子処方箋",
                        })
                      );
                      navigate(PRESCRIPTION_DIRECTOR, {
                        state: {
                          weekList,
                          guideType,
                        },
                      });
                    }}
                    style={{
                      height: "4vh",
                      variant: "subtitle1",
                    }}
                  />
                </Stack>
                <Stack
                  marginTop="5%"
                  component={Paper}
                  elevation={0}
                  variant="outlined"
                >
                  <Stack
                    direction={"column"}
                    justifyContent="space-around"
                    alignItems="center"
                    border="1px solid rgba(0, 0, 0, 0.12)"
                    divider={<Divider orientation="vertical" flexItem />}
                  >
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        alignSelf="baseline"
                        padding="0 0 0 16px"
                        height="32px"
                      >
                        <Typography
                          width="30%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お薬説明
                        </Typography>
                        <Typography width="70%" marginLeft="16px">
                          ビデオ通話
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        alignSelf="baseline"
                        padding="0 0 0 16px"
                        height="32px"
                      >
                        <Typography
                          width="30%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お会計
                        </Typography>
                        <Typography width="70%" marginLeft="16px">
                          オンライン決済
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        alignSelf="baseline"
                        padding="0 0 0 16px"
                        height="32px"
                      >
                        <Typography
                          width="30%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          原本提出
                        </Typography>
                        <Typography width="70%" marginLeft="16px">
                          提出不要
                        </Typography>
                      </Box>
                    </Box>
                    <Box width="100%">
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        alignSelf="baseline"
                        padding="0 0 0 16px"
                        height="32px"
                      >
                        <Typography
                          width="30%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お薬お渡し
                        </Typography>
                        <Typography width="70%" marginLeft="16px">
                          ロッカー
                        </Typography>
                      </Box>
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
              <hr style={{ marginTop: "5%", marginBottom: 0 }}></hr>
            </>
          )}
          {preState.includes("3") && (
            <>
              <Stack width="95%" marginLeft="auto" marginRight="auto">
                <Stack
                  direction="row"
                  justifyContent="space-around"
                  alignItems="center"
                  alignSelf="baseline"
                  marginTop="5%"
                >
                  <MainColorButton
                    label="病院からFAXで送付済"
                    onClick={() => {
                      store.dispatch(
                        setPrescriptionType({
                          id: "3",
                          name: "FAX",
                        })
                      );
                      navigate(PRESCRIPTION_DIRECTOR, {
                        state: {
                          weekList,
                          guideType,
                        },
                      });
                    }}
                    style={{
                      height: "4vh",
                      variant: "subtitle1",
                    }}
                  />
                </Stack>

                <Stack
                  marginTop="5%"
                  component={Paper}
                  elevation={0}
                  variant="outlined"
                >
                  <Stack
                    direction={"column"}
                    justifyContent="space-around"
                    alignItems="center"
                    border="1px solid rgba(0, 0, 0, 0.12)"
                    divider={<Divider orientation="vertical" flexItem />}
                  >
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        alignSelf="baseline"
                        padding="0 0 0 16px"
                        height="32px"
                      >
                        <Typography
                          width="30%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お薬説明
                        </Typography>
                        <Typography width="70%" marginLeft="16px">
                          ビデオ通話
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        alignSelf="baseline"
                        padding="0 0 0 16px"
                        height="32px"
                      >
                        <Typography
                          width="30%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お会計
                        </Typography>
                        <Typography width="70%" marginLeft="16px">
                          オンライン決済
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        alignSelf="baseline"
                        padding="0 0 0 16px"
                        height="32px"
                      >
                        <Typography
                          width="30%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          原本提出
                        </Typography>
                        <Typography width="70%" marginLeft="16px">
                          提出不要
                        </Typography>
                      </Box>
                    </Box>
                    <Box width="100%">
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        alignSelf="baseline"
                        padding="0 0 0 16px"
                        height="32px"
                      >
                        <Typography
                          width="30%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お薬お渡し
                        </Typography>
                        <Typography width="70%" marginLeft="16px">
                          ロッカー
                        </Typography>
                      </Box>
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
              <hr style={{ marginTop: "5%", marginBottom: 0 }}></hr>
            </>
          )}
          {preState.includes("1") && (
            <>
              <Stack width="95%" marginLeft="auto" marginRight="auto">
                <Stack
                  direction="row"
                  justifyContent="space-around"
                  alignItems="center"
                  alignSelf="baseline"
                  marginTop="5%"
                >
                  <MainColorButton
                    label="処方箋の写真を送る"
                    onClick={() => {
                      store.dispatch(
                        setPrescriptionType({
                          id: "1",
                          name: "画像",
                        })
                      );
                      navigate(PRESCRIPTION_DIRECTOR, {
                        state: {
                          weekList,
                        },
                      });
                    }}
                    style={{
                      height: "4vh",
                      variant: "subtitle1",
                    }}
                  />
                </Stack>
                <Stack
                  marginTop="5%"
                  component={Paper}
                  elevation={0}
                  variant="outlined"
                >
                  <Stack
                    direction={"column"}
                    justifyContent="space-around"
                    alignItems="center"
                    border="1px solid rgba(0, 0, 0, 0.12)"
                    divider={<Divider orientation="vertical" flexItem />}
                  >
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        alignSelf="baseline"
                        padding="0 0 0 12px"
                        height="32px"
                      >
                        <Typography
                          width="28%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お薬説明
                        </Typography>
                        <Typography
                          marginLeft="12px"
                          width="41%"
                          height="100%"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                          display="flex"
                          alignItems="center"
                        >
                          ビデオ通話
                        </Typography>
                        <Typography marginLeft="12px">店舗</Typography>
                      </Box>
                    </Box>
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        alignSelf="baseline"
                        padding="0 0 0 12px"
                        height="32px"
                      >
                        <Typography
                          width="28%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お会計
                        </Typography>
                        <Typography
                          marginLeft="12px"
                          width="41%"
                          height="100%"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                          display="flex"
                          alignItems="center"
                        >
                          店舗
                        </Typography>
                        <Typography marginLeft="12px">店舗</Typography>
                      </Box>
                    </Box>
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        alignSelf="baseline"
                        padding="0 0 0 12px"
                        height="32px"
                      >
                        <Typography
                          width="28%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          原本提出
                        </Typography>
                        <Typography
                          marginLeft="12px"
                          width="41%"
                          height="100%"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                          display="flex"
                          alignItems="center"
                        >
                          店舗提出
                        </Typography>
                        <Typography marginLeft="12px">店舗提出</Typography>
                      </Box>
                    </Box>
                    <Box width="100%">
                      <Box
                        display="flex"
                        alignItems="center"
                        alignSelf="baseline"
                        padding="0 0 0 12px"
                        height="32px"
                      >
                        <Typography
                          width="28%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お薬お渡し
                        </Typography>
                        <Typography
                          marginLeft="12px"
                          width="41%"
                          height="100%"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                          display="flex"
                          alignItems="center"
                        >
                          店舗
                        </Typography>
                        <Typography marginLeft="12px">店舗</Typography>
                      </Box>
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
              <hr style={{ marginTop: "5%", marginBottom: 0 }}></hr>
            </>
          )}
          {preState.includes("2") && (
            <>
              <Stack width="95%" marginLeft="auto" marginRight="auto">
                <Stack
                  direction="row"
                  justifyContent="space-around"
                  alignItems="center"
                  alignSelf="baseline"
                  marginTop="5%"
                >
                  <MainColorButton
                    label="処方箋のQRコードを読込"
                    onClick={() => {
                      store.dispatch(
                        setPrescriptionType({
                          id: "2",
                          name: "QR",
                        })
                      );
                      navigate(PRESCRIPTION_DIRECTOR, {
                        state: {
                          weekList,
                        },
                      });
                    }}
                    style={{
                      height: "4vh",
                      variant: "subtitle1",
                    }}
                  />
                </Stack>
                <Stack
                  marginTop="5%"
                  component={Paper}
                  elevation={0}
                  variant="outlined"
                >
                  <Stack
                    direction={"column"}
                    justifyContent="space-around"
                    alignItems="center"
                    border="1px solid rgba(0, 0, 0, 0.12)"
                    divider={<Divider orientation="vertical" flexItem />}
                  >
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        alignSelf="baseline"
                        padding="0 0 0 12px"
                        height="32px"
                      >
                        <Typography
                          width="28%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お薬説明
                        </Typography>
                        <Typography
                          marginLeft="12px"
                          width="41%"
                          height="100%"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                          display="flex"
                          alignItems="center"
                        >
                          ビデオ通話
                        </Typography>
                        <Typography marginLeft="12px">店舗</Typography>
                      </Box>
                    </Box>
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        alignSelf="baseline"
                        padding="0 0 0 12px"
                        height="32px"
                      >
                        <Typography
                          width="28%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お会計
                        </Typography>
                        <Typography
                          marginLeft="12px"
                          width="41%"
                          height="100%"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                          display="flex"
                          alignItems="center"
                        >
                          店舗
                        </Typography>
                        <Typography marginLeft="12px">店舗</Typography>
                      </Box>
                    </Box>
                    <Box
                      width="100%"
                      borderBottom="1px solid rgba(0, 0, 0, 0.12)"
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        alignSelf="baseline"
                        padding="0 0 0 12px"
                        height="32px"
                      >
                        <Typography
                          width="28%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          原本提出
                        </Typography>
                        <Typography
                          marginLeft="12px"
                          width="41%"
                          height="100%"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                          display="flex"
                          alignItems="center"
                        >
                          店舗提出
                        </Typography>
                        <Typography marginLeft="12px">店舗提出</Typography>
                      </Box>
                    </Box>
                    <Box width="100%">
                      <Box
                        display="flex"
                        alignItems="center"
                        alignSelf="baseline"
                        padding="0 0 0 12px"
                        height="32px"
                      >
                        <Typography
                          width="28%"
                          height="100%"
                          display="flex"
                          alignItems="center"
                          color="#4A7E00"
                          fontWeight="700"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                        >
                          お薬お渡し
                        </Typography>
                        <Typography
                          marginLeft="12px"
                          width="41%"
                          height="100%"
                          borderRight="1px solid rgba(0, 0, 0, 0.12)"
                          display="flex"
                          alignItems="center"
                        >
                          店舗
                        </Typography>
                        <Typography marginLeft="12px">店舗</Typography>
                      </Box>
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
            </>
          )}
        </Box>
      </div>
    </>
  );
};

export default PrescriptionTypeSelector;
